module.exports = __webpack_public_path__ + "static/media/upload.d3cd06c1.svg";